import client from './client'

export const poolsApi = {
  list: () => client.get('/pools'),
  get: (id) => client.get(`/pools/${id}`),
  create: (data) => client.post('/pools', data),
  update: (id, data) => client.put(`/pools/${id}`, data),
  advancePhase: (id) => client.post(`/pools/${id}/advance-phase`),
  revertPhase: (id) => client.post(`/pools/${id}/revert-phase`),
  addUser: (poolId, userId) => client.post(`/pools/${poolId}/users`, { userId }),
  removeUser: (poolId, userId) => client.delete(`/pools/${poolId}/users/${userId}`),
  listUsers: () => client.get('/users'),
  getMembers: (poolId) => client.get(`/pools/${poolId}/members`),
  generateShareToken: (id) => client.post(`/pools/${id}/share-token`),
  revokeShareToken: (id) => client.delete(`/pools/${id}/share-token`),
  getPublicShows: (shareToken) => client.get(`/public/pools/${shareToken}/shows`)
}
